import { render, staticRenderFns } from "./TutorBreakCardUpcomingBreak.vue?vue&type=template&id=b37a0f6e&"
import script from "./TutorBreakCardUpcomingBreak.vue?vue&type=script&lang=js&"
export * from "./TutorBreakCardUpcomingBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports